import React from 'react';
import clsx from 'clsx';
import useIntersectionObserver from '@react-hook/intersection-observer';

import { Body, Title } from '@edx/components/typography';

import { ArticleProps } from '../';

export const ArticleRight: React.FC<ArticleProps> = ({ title, content, bgImage }) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const { isIntersecting } = useIntersectionObserver(ref);

  return (
    <article className="relative overflow-hidden border-t border-b border-white border-opacity-10">
      <div className="w-full flex flex-row overflow-hidden">
        <div className="w-1/2 flex-shrink-0" />
        <div className="hidden sm:block flex-shrink-0 pr-4">
          <picture>
            <source media="(min-width: 1122px)" srcSet={bgImage.large} />
            <source media="(min-width: 641px)" srcSet={bgImage.medium} />
            <img
              className={clsx(
                'blend-lighten object-cover object-left opacity-40 md:opacity-100 transition-all duration-200 ease-in-out',
                !isIntersecting && 'filter-grayscale'
              )}
              src={bgImage.small}
              alt=""
            />
          </picture>
        </div>
      </div>

      <div className="static sm:absolute inset-0 flex items-center">
        <div className="max-w-5xl px-4 md:px-10 lg:px-0 py-12 sm:py-0 mx-auto grid grid-cols-12 gap-4">
          <div className="col-span-12 flex flex-row-reverse items-center md:flex-row relative sm:col-span-7 md:col-span-6">
            <div className="font-body left-0 text-base text-gray-500 w-full">
              <div
                className={clsx(
                  'border-2 border-primary-500 transition-all duration-200 ease-in-out',
                  isIntersecting ? 'w-8' : 'w-0'
                )}
              />

              <div className="relative mt-2">
                <Title className="text-gray-300 leading-tight">{title}</Title>

                <div ref={ref} className="mt-6 space-y-4">
                  {typeof content === 'string' ? (
                    <Body>{content}</Body>
                  ) : (
                    content.map((paragraph, index) => <Body key={`${title}-${index}`}>{paragraph}</Body>)
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
  );
};
